import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React, { FC } from "react";

import { useFeatureEnabled } from "@/features/common/hooks/useFeatureEnabled";
import { FollowUserButtonView } from "@/features/follow/components/followUserButton/FollowUserButtonView";
import { ActivateChatButton } from "@/features/message/components/ActivateChatButton";
import { ProfileSubscribeButtonProps } from "@/features/subscription/components/ProfileSubscribeButton";
import { ReportUserButton } from "@/features/user/components";
import { FeatureNameEnum } from "@/generated/generated-hooks";

type ProfileGroupButtonsProps = ProfileSubscribeButtonProps;

export const ProfileGroupButtons: FC<ProfileGroupButtonsProps> = (props) => {
  const { writer } = props;
  const { _id: writerId, accountName } = writer ?? {};
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const isOnOverlay = !smDown;
  const { isEnabled } = useFeatureEnabled();
  const isDirectMessageEnabled = isEnabled(FeatureNameEnum.DirectMessage);

  return (
    <div className="flex w-full" data-test-id="ProfileGroupButtons-container">
      {/* <div className="flex flex-1"> */}
      {/* <div className="flex w-3/5 md:button-lg">
          <ProfileSubscribeButton
            channel={channel}
            writer={writer}
            isOnOverlay={isOnOverlay}
          />
        </div> */}
      <div className="flex flex-grow md:button-sm ml-2">
        <FollowUserButtonView
          writerId={writerId}
          isOnOverlay={isOnOverlay}
          fullWidth={true}
        />
      </div>
      {/* </div> */}

      {isDirectMessageEnabled && (
        <div className="ml-2">
          <ActivateChatButton
            userId={writerId}
            accountName={accountName}
            isOnOverlay={isOnOverlay}
          />
        </div>
      )}

      <div className="ml-2">
        <ReportUserButton isOnOverlay={isOnOverlay} />
      </div>
    </div>
  );
};
